import React from "react";
import ModalLayout from "../../../../../../components/ModalLayout";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  image?: string;
}

export default function PreviewImageModal(props: Props) {
  const { image, setOpen, open } = props;

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <img
        style={{
          objectFit: "contain",
        }}
        src={image}
        alt=""
      />
    </ModalLayout>
  );
}
